import axiosInstance from "./global-instance";
import createScopedApi from "./createScopedApi";
import { bffApiUrl } from "../constants/url-constants";
const BASE_API_URL = `${bffApiUrl()}/api`;
export default createScopedApi(BASE_API_URL, axiosInstance);

